<template>
  <swatchs-picker dir="ltr" v-model="valData" :required="required" :id="id"/>
</template>

<script>
  import { Swatches } from 'vue-color'
  export default {
    components:{
      'swatchs-picker': Swatches
    },
    props: {
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      value: {
        type: String,
        default : ''
      },
      required: [Boolean, Function],
    },

    computed: {
      valData: {
        get() {
          return this.value
        },
        set(value) {
          const hexValue = value.hex
          this.$emit('input', hexValue)
        }
      }
    },
  }
</script>

<style lang="scss">
</style>
